import React from "react";
import BaseField from "./BaseField";

export default function TextField({
  field,
  value,
  setValue,
  openViewer,
  renderInlineChildren,
  previewMode = false,
}) {
  const required = !!field.required;
  const label = field.label || "Text";

  return (
    <BaseField
      field={field}
      value={value}
      setValue={setValue}
      openViewer={openViewer}
      renderInlineChildren={renderInlineChildren}
      previewMode={previewMode}
    >
      {/* Label */}
      <h3 className="text-gray-800 dark:text-gray-100 text-lg font-bold mb-3 text-center">
        {label} {required && <span className="text-orange-500">*</span>}
      </h3>

      {/* Text input */}
      <input
        type="text"
        value={value?.text ?? value ?? ""}
        onChange={(e) =>
          setValue({
            ...(value || {}),
            text: e.target.value,
          })
        }
        placeholder="Enter answer"
        className="border-2 border-orange-500 rounded-lg p-3 bg-white dark:bg-gray-700 text-center text-base text-gray-800 dark:text-gray-100 mt-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-400"
      />
    </BaseField>
  );
}
